import { Component, OnInit } from '@angular/core';
import { Entidade } from 'app/interfaces/enum/entidade.enum';
import { PeriodoFiltroDashboard } from 'app/interfaces/enum/periodo-filtro-dashboard';
import { Produto } from 'app/interfaces/enum/produto.enum';
import { StatusProcessoTr } from 'app/interfaces/enum/processo-tr-status';
import { StatusOportunidadeOfertaTr } from 'app/interfaces/enum/status-oportunidade-oferta-tr';
import { HomeCrmResumo } from 'app/interfaces/home-crm-resumo';
import { HomeOportunidadeOferta } from 'app/interfaces/home-oportunidade-oferta';
import { HomeProcesso } from 'app/interfaces/home-processo';
import { Atividade } from 'app/interfaces/atividade';
import { AgendaHttpService } from 'app/main/agenda/agenda-http.service';
import { FaturaTrHttpService } from 'app/main/faturatr/fatura-tr-http.service';
import { OportunidadeOfertaTrHttpService } from 'app/main/oportunidadeofertatr/oportunidadeoferta-tr-http.service';
import { ParceiroHttpService } from 'app/main/parceiro/parceiro-http.service';
import { ProcessoTrHttpService } from 'app/main/processotr/processo-tr-http.service';
import handleErrorMessage from 'app/utils/error-message-handler';
import { MessageService } from 'app/utils/toastr-custom/message.service';
import { SessionStorageService } from 'app/utils/session-storage.service';
import { TimezoneService } from 'app/utils/timezone.service';
import { ParametroUtilsService } from 'app/utils/parametro-utils.service';
import moment from 'moment';
import { EMPTY, expand, reduce } from 'rxjs';

interface AtividadeDashboardTr {
  atividadeId: string;
  data: string;
  horario: string;
  descricao: string;
  detalhe: string;
  status: string;
  statusClass: string;
  vencida: boolean;
  icone: string;
}

interface AlertaDashboardTr {
  titulo: string;
  descricao: string;
  status: keyof typeof StatusOportunidadeOfertaTr | StatusProcessoTr;
  rota: '/oportunidadeOfertaTr/list' | '/processoTr';
  icone: string;
  tone: string;
}

@Component({
  selector: 'app-home-transporte-rodoviario',
  templateUrl: './home-transporte-rodoviario.component.html',
  styleUrls: ['./home-transporte-rodoviario.component.scss'],
})
export class HomeTransporteRodoviarioComponent implements OnInit {
  carregandoOferta = true;
  carregandoProcesso = true;
  carregandoCrm = true;
  erroOferta = false;
  erroProcesso = false;

  dataAtualizacao = new Date();
  labelPeriodoProcesso = 'Últimos 30 dias';
  labelPeriodoOferta = 'Últimos 30 dias';
  periodoFiltro = PeriodoFiltroDashboard;

  processosPorStatus: HomeProcesso[] = [];
  ofertasPorStatus: HomeOportunidadeOferta[] = [];
  totalProcessos = 0;
  totalOfertas = 0;
  ofertasEmAndamento: number | null = null;
  processosEmAndamento: number | null = null;
  processosAguardandoProgramacao: number | null = null;
  romaneiosEmitidosHoje: number | null = null;
  totalRomaneiosEmitidos: number | null = null;
  faturasPendentes: number | null = null;
  totalFaturas: number | null = null;

  semDadosOferta = false;
  semDadosProcesso = false;

  resumo: HomeCrmResumo = {
    totalContas: 0,
    suspects: 0,
    prospects: 0,
    leads: 0,
    clientesAtivos: 0,
    percentualClientesAtivos: 0,
  };

  proximasAtividades: AtividadeDashboardTr[] = [];
  carregandoAtividades = true;
  erroAtividades = false;

  alertasPendencias: AlertaDashboardTr[] = [
    {
      titulo: 'Ofertas em andamento',
      descricao: 'Ofertas com status Em andamento',
      status: 'EM_ANDAMENTO',
      rota: '/oportunidadeOfertaTr/list',
      icone: 'alert-circle',
      tone: 'danger',
    },
    {
      titulo: 'Ofertas aguardando solicitação de carga',
      descricao: 'Ofertas aprovadas para solicitação de carga',
      status: 'APROVADO',
      rota: '/oportunidadeOfertaTr/list',
      icone: 'truck',
      tone: 'warning',
    },
    {
      titulo: 'Processos sem programação',
      descricao: 'Processos aguardando programação',
      status: StatusProcessoTr.AGUARDANDO_PROGRAMACAO,
      rota: '/processoTr',
      icone: 'navigation',
      tone: 'orange',
    },
    {
      titulo: 'Processos com programação realizada',
      descricao: 'Processos com status Programação realizada',
      status: StatusProcessoTr.PROGRAMACAO_REALIZADA,
      rota: '/processoTr',
      icone: 'file-text',
      tone: 'amber',
    },
    {
      titulo: 'Processos finalizados operacionalmente',
      descricao: 'Processos com operação finalizada',
      status: StatusProcessoTr.FINALIZADO_OPERACIONALMENTE,
      rota: '/processoTr',
      icone: 'check-circle',
      tone: 'green',
    },
  ];

  readonly coresProcesso = ['#0f3d73', '#0f62ac', '#2f8fd8', '#5bb8ef', '#28c76f', '#ff9f43', '#ea5455', '#7367f0'];

  readonly coresOferta = ['#0f3d73', '#0f62ac', '#00a9e8', '#28c76f', '#7367f0', '#ff9f43', '#ea5455'];

  readonly coresOfertaPorStatus: Record<keyof typeof StatusOportunidadeOfertaTr, string> = {
    APROVADO: this.coresOferta[0],
    EM_ANDAMENTO: this.coresOferta[1],
    LIBERADO: this.coresOferta[3],
    REPROVADO: this.coresOferta[6],
    VENCIDO: this.coresOferta[4],
  };

  constructor(
    private _parceiroHttpService: ParceiroHttpService,
    private _processoTrHttpService: ProcessoTrHttpService,
    private _oportunidadeOfertaTrHttpService: OportunidadeOfertaTrHttpService,
    private _faturaTrHttpService: FaturaTrHttpService,
    private _agendaHttpService: AgendaHttpService,
    private _sessionStorageService: SessionStorageService,
    private _timezoneService: TimezoneService,
    private _messageService: MessageService,
    private _parametroUtilsService: ParametroUtilsService
  ) {}

  ngOnInit(): void {
    this.getResumoCrm();
    this.getFaturasPendentes();
    this.getProximasAtividades();
    this.getInformacaoGraficoProcessoRodoviario();
    this.getInformacaoGraficoOportunidadeOfertasRodoviario();
    this.getEvolucaoMensalOfertas();
  }

  get carregando(): boolean {
    return this.carregandoOferta || this.carregandoProcesso;
  }

  getStatusAlerta(alerta: AlertaDashboardTr): AlertaDashboardTr['status'] {
    if (
      alerta.rota === '/oportunidadeOfertaTr/list' &&
      alerta.status === 'LIBERADO' &&
      this._parametroUtilsService.getParametroByNome('VALIDACOES_OFERTA_TR_OBRIGATORIAS')?.valor === false
    ) {
      return 'APROVADO';
    }
    return alerta.status;
  }

  getQuantidadeAlerta(alerta: AlertaDashboardTr): number | null {
    const oferta = alerta.rota === '/oportunidadeOfertaTr/list';
    if (oferta ? this.carregandoOferta || this.erroOferta : this.carregandoProcesso || this.erroProcesso) {
      return null;
    }
    const dados = oferta ? this.ofertasPorStatus : this.processosPorStatus;
    const status = this.getStatusAlerta(alerta);
    return dados.reduce((total, item) => total + (item.status === status ? (item.quantidade ?? 0) : 0), 0);
  }

  getFaturasPendentes(): void {
    this.faturasPendentes = null;
    this.totalFaturas = null;

    this._faturaTrHttpService
      .getAll({
        produtos: [Produto.TR],
        statusConferencia: 'false',
        tipoFatura: ['PROCESSOS', 'ADMINISTRATIVO'],
        size: 1,
      })
      .subscribe({
        next: result => {
          this.faturasPendentes = result.totalElements ?? 0;
          this.dataAtualizacao = new Date();
        },
        error: error => {
          handleErrorMessage(this._messageService, error);
        },
      });

    this._faturaTrHttpService
      .getAll({
        produtos: [Produto.TR],
        tipoFatura: ['PROCESSOS', 'ADMINISTRATIVO'],
        size: 1,
      })
      .subscribe({
        next: result => {
          this.totalFaturas = result.totalElements ?? 0;
          this.dataAtualizacao = new Date();
        },
        error: error => {
          handleErrorMessage(this._messageService, error);
        },
      });
  }

  getProximasAtividades(): void {
    this.carregandoAtividades = true;
    this.erroAtividades = false;
    this.proximasAtividades = [];
    const usuario = JSON.parse(this._sessionStorageService.getItem('user') || '{}');
    if (!usuario.usuId) {
      this.erroAtividades = true;
      this.carregandoAtividades = false;
      return;
    }

    const filtro = {
      entidade: Entidade.USUARIO,
      responsavelId: String(usuario.usuId),
      dataInicial: '',
      dataFinal: '',
      concluido: false,
      sort: 'dataInicial,asc',
      page: 0,
      size: 1000,
    };
    this._agendaHttpService
      .buscaAtividades(filtro)
      .pipe(
        expand((pagina, indice) => {
          const proximaPagina = (pagina.number ?? indice) + 1;
          const totalPaginas = pagina.totalPages ?? Math.ceil((pagina.totalElements ?? 0) / filtro.size);
          return proximaPagina < totalPaginas
            ? this._agendaHttpService.buscaAtividades({ ...filtro, page: proximaPagina })
            : EMPTY;
        }),
        reduce((atividades, pagina) => atividades.concat(pagina.content ?? []), [] as Atividade[])
      )
      .subscribe({
        next: atividades => {
          const agora = Date.now();
          const prazo = (atividade: Atividade) => new Date(atividade.dataFinal).getTime();
          const vencida = (atividade: Atividade) => !(prazo(atividade) > agora);
          this.proximasAtividades = atividades
            .filter(atividade => atividade?.atividadeId && !atividade.concluido)
            .sort((a, b) => {
              const prioridade = Number(vencida(b)) - Number(vencida(a));
              const dataA = new Date(a.dataInicial).getTime();
              const dataB = new Date(b.dataInicial).getTime();
              return prioridade || (Number.isFinite(dataA) ? dataA : Infinity) - (Number.isFinite(dataB) ? dataB : Infinity);
            })
            .map(atividade => {
              const dataHora = atividade.dataInicial ? moment(this._timezoneService.utcToUserString(atividade.dataInicial)) : null;
              const estaVencida = vencida(atividade);
              const proximaDoVencimento = !estaVencida && prazo(atividade) - agora <= 30 * 60 * 1000;

              return {
                atividadeId: atividade.atividadeId,
                data: dataHora?.isValid() ? dataHora.format('DD/MM') : '--/--',
                horario: atividade.diaTodo ? 'Dia todo' : dataHora?.isValid() ? dataHora.format('HH:mm') : '--:--',
                descricao: atividade.assunto || atividade.descricao || 'Atividade',
                detalhe: atividade.tipoAtividade || '',
                status: estaVencida ? 'Vencida' : proximaDoVencimento ? 'Próximo ao vencimento' : 'Em tempo',
                statusClass: estaVencida ? 'status-danger' : proximaDoVencimento ? 'status-warning' : 'status-success',
                vencida: estaVencida,
                icone: 'calendar',
              };
            });
          this.carregandoAtividades = false;
        },
        error: error => {
          this.proximasAtividades = [];
          this.erroAtividades = true;
          this.carregandoAtividades = false;
          handleErrorMessage(this._messageService, error);
        },
      });
  }

  getResumoCrm(): void {
    this.carregandoCrm = true;

    this._parceiroHttpService.getResumoHomeCrm().subscribe({
      next: (resumo: HomeCrmResumo) => {
        this.resumo = resumo;
        this.atualizarGraficoCrm();
        this.carregandoCrm = false;
      },
      error: error => {
        this.carregandoCrm = false;
        handleErrorMessage(this._messageService, error);
      },
    });
  }

  filtroPeriodoOfertas(dias: number): void {
    this.labelPeriodoOferta = `Últimos ${dias} dias`;

    const hoje = new Date();
    const inicio = new Date();

    inicio.setDate(hoje.getDate() - dias);

    this.getInformacaoGraficoOportunidadeOfertasRodoviario(inicio.toISOString().substring(0, 10), hoje.toISOString().substring(0, 10));
  }

  filtroPeriodoProcesso(dias: number): void {
    this.labelPeriodoProcesso = `Últimos ${dias} dias`;

    const hoje = new Date();
    const inicio = new Date();

    inicio.setDate(hoje.getDate() - dias);

    this.getInformacaoGraficoProcessoRodoviario(inicio.toISOString().substring(0, 10), hoje.toISOString().substring(0, 10));
  }

  getInformacaoGraficoProcessoRodoviario(dataInicial?: string, dataFinal?: string): void {
    this.carregandoProcesso = true;
    this.erroProcesso = false;
    this.processosEmAndamento = null;
    this.processosAguardandoProgramacao = null;
    this.romaneiosEmitidosHoje = null;
    this.totalRomaneiosEmitidos = null;

    this._processoTrHttpService.getInformacaoGraficoProcessoRodoviario(dataInicial, dataFinal).subscribe({
      next: result => {
        const dados = result.processosPorStatus ?? [];
        this.romaneiosEmitidosHoje = result.romaneios.emitidosHoje;
        this.totalRomaneiosEmitidos = result.romaneios.totalEmitidos;

        this.processosPorStatus = dados;
        this.totalProcessos = dados.reduce((total, item) => total + (item.quantidade ?? 0), 0);
        const statusEmAndamento = new Set<string>([
          StatusProcessoTr.EM_ANDAMENTO,
          StatusProcessoTr.AUDITADO,
          StatusProcessoTr.AGUARDANDO_PROGRAMACAO,
          StatusProcessoTr.PROGRAMACAO_REALIZADA,
        ]);
        this.processosEmAndamento = dados.reduce((total, item) => total + (statusEmAndamento.has(item.status) ? (item.quantidade ?? 0) : 0), 0);
        this.processosAguardandoProgramacao = this.getQuantidadeProcesso('AGUARDANDO_PROGRAMACAO');

        this.donutChartProcesso = {
          ...this.donutChartProcesso,
          series: dados.map(item => item.quantidade ?? 0),
          labels: dados.map(item => this.getDescricaoStatusProcesso(item.status)),
        };

        this.semDadosProcesso = dados.length === 0 || this.totalProcessos === 0;
        this.dataAtualizacao = new Date();
        this.carregandoProcesso = false;
      },
      error: error => {
        this.carregandoProcesso = false;
        this.erroProcesso = true;
        this.semDadosProcesso = true;
        handleErrorMessage(this._messageService, error);
      },
    });
  }

  getInformacaoGraficoOportunidadeOfertasRodoviario(dataInicial?: string, dataFinal?: string): void {
    this.carregandoOferta = true;
    this.erroOferta = false;
    this.ofertasEmAndamento = null;

    this._oportunidadeOfertaTrHttpService.getInformacaoGraficoOportunidadeOfertasRodoviario(dataInicial, dataFinal).subscribe({
      next: (result: HomeOportunidadeOferta[]) => {
        const dados = result ?? [];

        this.ofertasPorStatus = dados;
        const statusEmAndamento: keyof typeof StatusOportunidadeOfertaTr = 'EM_ANDAMENTO';
        this.ofertasEmAndamento = dados.reduce((total, item) => total + (item.status === statusEmAndamento ? (item.quantidade ?? 0) : 0), 0);
        this.totalOfertas = dados.reduce((total, item) => total + (item.quantidade ?? 0), 0);

        this.donutChartOferta = {
          ...this.donutChartOferta,
          colors: dados.map(item => this.getCorOferta(item.status)),
          series: dados.map(item => item.quantidade ?? 0),
          labels: dados.map(item => this.getDescricaoStatusOferta(item.status)),
        };

        this.semDadosOferta = dados.length === 0 || this.totalOfertas === 0;
        this.dataAtualizacao = new Date();
        this.carregandoOferta = false;
      },
      error: error => {
        this.carregandoOferta = false;
        this.erroOferta = true;
        this.semDadosOferta = true;
        handleErrorMessage(this._messageService, error);
      },
    });
  }

  getEvolucaoMensalOfertas(): void {
    this._oportunidadeOfertaTrHttpService.getEvolucaoMensalOfertas().subscribe({
      next: quantidades => {
        this.evolucaoChart = {
          ...this.evolucaoChart,
          colors: Object.keys(quantidades).map(status => this.getCorOferta(status)),
          series: Object.entries(quantidades).map(([status, data]) => ({
            name: StatusOportunidadeOfertaTr[status as keyof typeof StatusOportunidadeOfertaTr] ?? this.getDescricaoStatusOferta(status),
            data,
          })),
          xaxis: {
            ...this.evolucaoChart.xaxis,
            categories: Array.from({ length: 12 }, (_, mes) => moment().startOf('year').add(mes, 'months').locale('pt-br').format('MMM/YYYY')),
          },
        };
      },
      error: error => {
        handleErrorMessage(this._messageService, error);
      },
    });
  }

  getDescricaoStatusProcesso(status?: string): string {
    switch (status) {
      case StatusProcessoTr.EM_ANDAMENTO:
        return 'Em andamento';
      case StatusProcessoTr.AUDITADO:
        return 'Auditado';
      case 'CANCELADO':
        return 'Cancelado';
      case 'FINALIZADO_CONTABILMENTE':
        return 'Finalizado contabilmente';
      case 'FINALIZADO_OPERACIONALMENTE':
        return 'Finalizado operacionalmente';
      case StatusProcessoTr.AGUARDANDO_PROGRAMACAO:
        return 'Aguardando programação';
      case StatusProcessoTr.PROGRAMACAO_REALIZADA:
        return 'Programação realizada';
      default:
        return status ?? '-';
    }
  }

  getDescricaoStatusOferta(status?: string): string {
    switch (status) {
      case 'LIBERADO':
        return StatusOportunidadeOfertaTr.LIBERADO;
      case 'REPROVADO':
        return 'Reprovado';
      case 'APROVADO':
        return 'Aprovado';
      case 'AGUARDANDO_PRICING':
        return 'Aguardando Pricing';
      case 'AGUARDANDO_PARCEIRO':
        return 'Aguardando Parceiro';
      case 'P2':
        return 'P2';
      case 'PRE_PROPOSTA':
        return 'Pré-proposta';
      case 'OFERTA_DISPONIVEL_PARA_ENVIO':
        return 'Oferta disponível para envio';
      case 'EM_ANDAMENTO':
        return 'Em andamento';
      default:
        return status ?? '-';
    }
  }

  getPercentual(quantidade: number | undefined, total: number): number {
    if (!total) {
      return 0;
    }

    return Math.round(((quantidade ?? 0) / total) * 100);
  }

  getCorProcesso(index: number): string {
    return this.coresProcesso[index % this.coresProcesso.length];
  }

  getCorOferta(status?: string): string {
    return this.coresOfertaPorStatus[status as keyof typeof StatusOportunidadeOfertaTr] ?? this.coresOferta[0];
  }

  private ajustarTextoCentralRosca(valor: string | number, chart: any, seletor: string, tamanhoFonte: number): string {
    const texto = String(valor);
    const elemento = chart.globals.dom.baseEl.querySelector(seletor) as SVGTextElement;
    if (elemento) {
      elemento.textContent = texto;
      elemento.style.fontSize = `${tamanhoFonte}px`;
      const raioInterno = (chart.globals.radialSize * parseFloat(chart.config.plotOptions.pie.donut.size)) / 100;
      const larguraDisponivel = Math.max(1, raioInterno * 1.6);
      const larguraTexto = elemento.getComputedTextLength();
      if (larguraTexto > larguraDisponivel) {
        elemento.style.fontSize = `${(tamanhoFonte * larguraDisponivel) / larguraTexto}px`;
      }
    }
    return texto;
  }

  private getQuantidadeProcesso(status: string): number {
    return this.processosPorStatus.find(item => item.status === status)?.quantidade ?? 0;
  }

  private atualizarGraficoCrm(): void {
    this.funilChart = {
      ...this.funilChart,
      series: [this.resumo.suspects, this.resumo.prospects, this.resumo.leads, this.resumo.clientesAtivos],
      plotOptions: {
        ...this.funilChart.plotOptions,
        pie: {
          ...this.funilChart.plotOptions.pie,
          donut: {
            ...this.funilChart.plotOptions.pie.donut,
            labels: {
              ...this.funilChart.plotOptions.pie.donut.labels,
              total: {
                show: true,
                label: 'Contas',
                formatter: () => `${this.resumo.totalContas}`,
              },
            },
          },
        },
      },
    };
  }

  funilChart: any = {
    series: [],
    chart: {
      type: 'donut',
      height: 285,
    },
    labels: ['Suspects', 'Prospects', 'Leads', 'Clientes ativos'],
    colors: ['#82868B', '#FF9F43', '#00CFE8', '#28C76F'],
    legend: {
      position: 'bottom',
      horizontalAlign: 'center',
      fontSize: '12px',
      formatter: function (seriesName: string, opts: any) {
        const value = opts.w.globals.series[opts.seriesIndex];

        return `${seriesName}: ${value}`;
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      width: 0,
    },
    plotOptions: {
      pie: {
        donut: {
          size: '70%',
          labels: {
            show: true,
            name: {
              show: true,
            },
            value: {
              show: true,
            },
            total: {
              show: true,
              label: 'Contas',
              formatter: () => '0',
            },
          },
        },
      },
    },
  };

  donutChartProcesso: any = {
    series: [],
    chart: {
      ...this.funilChart.chart,
      height: 230,
      toolbar: { show: false },
    },
    labels: [],
    colors: this.coresProcesso,
    legend: { show: false },
    dataLabels: this.funilChart.dataLabels,
    tooltip: {
      y: { formatter: (valor: number) => valor },
    },
    stroke: this.funilChart.stroke,
    plotOptions: {
      pie: {
        customScale: 85 / parseFloat(this.funilChart.plotOptions.pie.donut.size),
        donut: {
          size: this.funilChart.plotOptions.pie.donut.size,
          labels: {
            show: true,
            name: {
              ...this.funilChart.plotOptions.pie.donut.labels.name,
              fontSize: '13px',
              formatter: (nome: string, _total: boolean, chart: any) =>
                this.ajustarTextoCentralRosca(nome, chart, '.apexcharts-datalabel-label', 13),
            },
            value: {
              ...this.funilChart.plotOptions.pie.donut.labels.value,
              fontSize: '22px',
              formatter: (valor: number, chart: any) =>
                this.ajustarTextoCentralRosca(valor, chart, '.apexcharts-datalabel-value', 22),
            },
            total: {
              show: true,
              showAlways: false,
              label: 'Processos',
              fontSize: '13px',
              formatter: (chart: any) =>
                this.ajustarTextoCentralRosca(
                  chart.globals.seriesTotals.reduce((total: number, valor: number) => total + valor, 0),
                  chart,
                  '.apexcharts-datalabel-value',
                  22
                ),
            },
          },
        },
      },
    },
    responsive: [
      {
        breakpoint: 575,
        options: { chart: { height: 210 } },
      },
    ],
  };

  donutChartOferta: any = {
    series: [],
    chart: {
      ...this.funilChart.chart,
      height: 230,
      toolbar: { show: false },
    },
    labels: [],
    colors: this.coresOferta,
    legend: { show: false },
    dataLabels: this.funilChart.dataLabels,
    tooltip: {
      y: { formatter: (valor: number) => valor },
    },
    stroke: this.funilChart.stroke,
    plotOptions: {
      pie: {
        customScale: 85 / parseFloat(this.funilChart.plotOptions.pie.donut.size),
        donut: {
          size: this.funilChart.plotOptions.pie.donut.size,
          labels: {
            show: true,
            name: {
              ...this.funilChart.plotOptions.pie.donut.labels.name,
              fontSize: '13px',
              formatter: (nome: string, _total: boolean, chart: any) =>
                this.ajustarTextoCentralRosca(nome, chart, '.apexcharts-datalabel-label', 13),
            },
            value: {
              ...this.funilChart.plotOptions.pie.donut.labels.value,
              fontSize: '22px',
              formatter: (valor: number, chart: any) =>
                this.ajustarTextoCentralRosca(valor, chart, '.apexcharts-datalabel-value', 22),
            },
            total: {
              show: true,
              showAlways: false,
              label: 'Ofertas',
              fontSize: '13px',
              formatter: (chart: any) =>
                this.ajustarTextoCentralRosca(
                  chart.globals.seriesTotals.reduce((total: number, valor: number) => total + valor, 0),
                  chart,
                  '.apexcharts-datalabel-value',
                  22
                ),
            },
          },
        },
      },
    },
    responsive: [
      {
        breakpoint: 575,
        options: { chart: { height: 210 } },
      },
    ],
  };

  evolucaoChart: any = {
    series: [],
    chart: {
      type: 'bar',
      stacked: true,
      height: 220,
      toolbar: { show: false },
      zoom: { enabled: false },
    },
    colors: this.coresOferta,
    plotOptions: { bar: { horizontal: false, columnWidth: '55%' } },
    dataLabels: { enabled: false },
    stroke: {
      width: 0,
    },
    markers: {
      size: 3,
      strokeWidth: 0,
    },
    xaxis: {
      categories: [],
      axisBorder: { show: false },
      axisTicks: { show: false },
      labels: { style: { colors: '#8b95a5', fontSize: '10px' } },
    },
    yaxis: {
      min: 0,
      forceNiceScale: true,
      decimalsInFloat: 0,
      labels: { style: { colors: '#8b95a5', fontSize: '10px' } },
    },
    grid: {
      borderColor: '#e9eef5',
      strokeDashArray: 4,
      padding: { left: 8, right: 8 },
    },
    legend: { show: true, position: 'bottom', fontSize: '11px' },
    tooltip: {
      shared: true,
      intersect: false,
      hideEmptySeries: true,
      y: { formatter: (valor: number) => `${Math.round(valor)} ofertas` },
    },
    noData: {
      text: 'Dados de evolução ainda não disponíveis',
      align: 'center',
      verticalAlign: 'middle',
      style: { color: '#8b95a5', fontSize: '13px' },
    },
  };
}
